import UncontrolledInputSearchableSelect from "components/inputs/UncontrolledInputSearchableSelect";
import { trpc2 } from "utils/trpc";

interface Props {
  integrationId: string;
  fieldValue: string;
  fieldError: any;
  onChange: any;
}

export default function EnhancedLinearTagSelector({ integrationId, fieldValue, fieldError, onChange }: Props): JSX.Element {
  const { data } = trpc2.v2.merge.fetchLinearTags.useQuery({ integrationId });

  const options =
    data?.map((option: any) => {
      return { value: option.name, label: option.name };
    }) ?? [];

  return (
    <div className="min-w-320 w-auto">
      <UncontrolledInputSearchableSelect options={options} val={fieldValue} onChange={onChange} error={fieldError} placeholder={"Select a status"} />
    </div>
  );
}
